import type { TableColumnsType } from 'antd';
import { DataTypeAR } from 'store/ducks/Reportings/types';

export const columns: TableColumnsType<DataTypeAR> = [
  {
    title: 'Name of the Financial Entity',
    width: 100,
    dataIndex: 'entity_name',
    key: 'entity_name',
    fixed: 'left',
  },
  {
    title: 'Function',
    width: 100,
    dataIndex: 'function_name',
    key: 'function_name',
  },
  {
    title: 'Function Description',
    width: 100,
    dataIndex: 'function_description',
    key: 'function_description',
  },
  {
    title: 'Third Party ICT Services',
    width: 100,
    dataIndex: 'ict_service_provider_name',
    key: 'ict_service_provider_name',
  },
  {
    title: 'Function Start Date',
    width: 100,
    dataIndex: 'function_start_date',
    key: 'function_start_date',
  },
  {
    title: 'Function End Date',
    width: 100,
    dataIndex: 'function_end_date',
    key: 'function_end_date',
  },
  {
    title: 'ICT Service Start Date',
    width: 100,
    dataIndex: 'ict_service_start_date',
    key: 'ict_service_start_date',
  },
  {
    title: 'ICT Service End Date',
    width: 100,
    dataIndex: 'ict_service_end_date',
    key: 'ict_service_end_date',
  },
];
